<main class="main">
    <p-toast key="default" position="bottom-left"></p-toast>
    <p-toast key="masquerade" position="bottom-right" [preventOpenDuplicates]="true"></p-toast>
    <router-outlet></router-outlet>
</main>
